import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLayoutGrid4Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M11,8H1v5.25c0,1.517,1.233,2.75,2.75,2.75h7.25V8Z", fill: "currentColor" }),
        React.createElement("path", { d: "M17,6.5v-1.75c0-1.517-1.233-2.75-2.75-2.75H3.75c-1.517,0-2.75,1.233-2.75,2.75v1.75H17Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M12.5,8v8h1.75c1.517,0,2.75-1.233,2.75-2.75v-5.25h-4.5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconRectLayoutGrid4Fill18.js.map